document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.page-description-section');

  if (!sections.length) return;

  sections.forEach(function (section) {
    var content = section.querySelector('[data-page-description-content]');
    var button = section.querySelector('[data-page-description-toggle]');

    if (!content || !button) return;

    setTimeout(function () {
      if (content.scrollHeight <= content.clientHeight + 10) {
        button.style.display = 'none';
      }
    }, 100);

    button.addEventListener('click', function () {
      content.classList.toggle('expanded');

      if (content.classList.contains('expanded')) {
        button.textContent = 'Discontinue Reading';
      } else {
        button.textContent = 'Continue Reading';
      }
    });
  });
});
